import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading5 } from 'components/shared/Typography.styled';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { StyledCta, StyledTitle } from './BlogRegisterCta.styled';

const BlogRegisterCta: React.FC = () => {
  const { t } = useI18n('blog');
  const { locale } = useRouter();

  return (
    <StyledCta>
      <StyledTitle>{t('registerCTA.title')}</StyledTitle>
      <Heading5 as="p">{t('registerCTA.desc')}</Heading5>
      <Link
        href={`${getAppUrl(
          APP_URLS.join,
          locale
        )}?locale=${locale}&source=footer-blog`}
        passHref
      >
        <ButtonLink
          variant="brandTalent"
          sizes="sm"
          onClick={(e) =>
            ServiceEventTracking.trackExternalLandingCtaClicked(
              e,
              `${getAppUrl(
                APP_URLS.join,
                locale
              )}?locale=${locale}&source=footer-blog`,
              'footer-blog'
            )
          }
        >
          <FontAwesomeIcon icon={faCheckCircle} />
          <span>{t('registerCTA.cta')}</span>
        </ButtonLink>
      </Link>
    </StyledCta>
  );
};

export default BlogRegisterCta;
